module.exports = __webpack_public_path__ + "./images/5ce6d9cc5f93bd8243fdcf473bbb1780.webp";